import Icon from "@core-components/icon/Icon";
import { Group } from "@mantine/core";

interface GradeProps {
  grade: number;
  author: string;
}

const Grade = ({ author, grade }: GradeProps) => {
  return (
    <Group gap={2}>
      {Array.from({ length: grade }).map((_, index) => (
        <Icon.TrustpilotStarFull key={`${author} ${index}`} size={20} />
      ))}
    </Group>
  );
};

export default Grade;
